export default __webpack_public_path__ + "static/brass_prices-f7f4579676310ece79adb4760e33aa6c.png";